import { render, staticRenderFns } from "./StatisticsAddNew.vue?vue&type=template&id=5debc178&scoped=true"
import script from "./StatisticsAddNew.vue?vue&type=script&lang=ts"
export * from "./StatisticsAddNew.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsAddNew.vue?vue&type=style&index=0&id=5debc178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5debc178",
  null
  
)

export default component.exports